/** Clé sous laquelle vit l'état du Pack IA, dans les paramètres de la société. */
export const CLE_PACK_IA = 'packIA';

/**
 * Le Pack IA est-il souscrit ?
 *
 * <p>Il est facturé en sus de l'abonnement : tant qu'il n'est pas pris, rien
 * de ce qu'il apporte ne doit paraître. Montrer une fonction qu'on ne peut pas
 * utiliser n'est pas une invitation à l'acheter, c'est une porte fermée sur
 * laquelle on a écrit « entrée ».
 *
 * <p>Absent vaut non souscrit : un client qui ne l'a jamais activé ne doit pas
 * le voir apparaître à la faveur d'une mise à jour.
 *
 * @param {object} [etat] état lu dans les paramètres de la société
 * @returns {boolean} vrai si le pack est actif
 */
export function packIaActif(etat) {
  return etat?.actif === true;
}

/**
 * Mois à partir duquel le Pack IA se facture, au format `AAAA-MM`.
 *
 * <p>L'activation n'est jamais rétroactive : un client qui ajoute le pack en
 * septembre le paie dès septembre, non depuis janvier. Et la désactivation
 * n'efface pas les mois déjà dus.
 *
 * @param {object} [etat] état lu dans les paramètres de la société
 * @returns {string|null} le mois d'activation, ou null si le pack n'a jamais été pris
 */
export function moisFacture(etat) {
  return etat?.depuis || null;
}

/**
 * Bascule l'état du Pack IA.
 *
 * <p>Le mois d'activation est posé à la souscription et conservé ensuite : il
 * dit depuis quand la facturation court, et une désactivation ne le réécrit
 * pas — le mois entamé reste dû.
 *
 * @param {object} [etat] état courant
 * @param {Date} [maintenant] date de référence
 * @returns {{actif: boolean, depuis: string|null, arreteLe: string|null}} le nouvel état
 */
export function basculePackIa(etat, maintenant = new Date()) {
  const mois = maintenant.getFullYear() + '-' + String(maintenant.getMonth() + 1).padStart(2, '0');

  if (packIaActif(etat)) {
    return { actif: false, depuis: moisFacture(etat), arreteLe: mois };
  }
  return { actif: true, depuis: mois, arreteLe: null };
}
